import { Injectable, Injector } from '@angular/core';
import { RestProviderService } from '../../services/rest-provider/rest-provider.service';
import { HttpClient } from '../../../../node_modules/@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SemNavigationService {
  private history: string[] = [];

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.history.push(e.urlAfterRedirects);
      });
  }

  public back(defaultUrl: string = '/cms/dashboard') {
    this.history.pop();
    const prev = this.history.pop();
    if (prev) {
      this.router.navigateByUrl(prev);
    } else {
      this.router.navigateByUrl(defaultUrl);
    }
  }
}
